export default __webpack_public_path__ + "static/media/claims.2aa096b5.svg";